import React from 'react'
import {Header, List, Segment} from 'semantic-ui-react'

const BeerRules = () =>
    <Segment>
        <Header as='h3' content='Øl-regler'/>
        <List bulleted>
            <List.Item>Svar/Avmelding mindre enn 24 timer før: 1 øl</List.Item>
            <List.Item>Svar/Avmelding mindre enn 12 timer før: 2 øl</List.Item>
            <List.Item>Svar/Avmelding mindre enn 4 timer før: 3 øl</List.Item>
            <List.Item>Ubesvart ved oppstart: 4 øl</List.Item>
        </List>
    </Segment>

export default BeerRules


// WEBPACK FOOTER //
// ./src/Components/BeerRules.js